// Angular
import { Component, EventEmitter, Input, Output } from '@angular/core';
// models
import { PeriodCode, Search } from 'src/app/models';

@Component({
    selector: 'app-searchable-page-wrapper',
    templateUrl: './searchable-page-wrapper.component.html',
    styleUrls: ['./searchable-page-wrapper.component.scss'],
    standalone: false
})
export class SearchablePageWrapperComponent {
    @Input() addBtnText: string = '';
    @Input() loading: boolean = false;
    @Input() newPath: string = '';
    @Input() periodSelector: boolean = false;
    @Input() periodOptions: PeriodCode[] = [];
    @Input() placeholder: string = '';
    @Input() currentSearch: Search = {};
    @Input() title: string = '';
    @Input() createLink: string = '';
    @Input() hideTerm: boolean = false;

    @Output() search: EventEmitter<boolean> = new EventEmitter<boolean>();

    onSearch(reset?: boolean): void {
        this.search.emit(reset);
    }
}
